<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-2">
            <label>Transaction Date</label>
            <date-picker ref="tran" v-model="transactionDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" ref="tran" type="text" v-else class="nepali-calendar" id="transactionDate"
                       v-model="transactionDate"/>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label>Voucher</label>
            <InputText v-model="voucherNo" id="code" disabled/>
          </div>

        </div>

        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="account">Account</label>
            <AutoComplete v-model="account" filterMatchMode='contains'
                          :suggestions="filteredAccounts" @complete="searchItem($event)"
                          field="name" ref="itm" @input="nepaliDate">
            </AutoComplete>
          </div>
          <div class="p-field p-col-12 p-md-1 align-self-end">
            <accountMasterDialog class="btn-btm-0" v-tooltip.top="'Add Account'" @set_account_master="set_account_master"/>
          </div>
          <div v-if="!this.account.enableCostCenter" class="p-field p-col-12 p-md-2">
            <label for="drAmount">Debit Amount</label>
            <InputNumber id="drAmount" bodyStyle="text-align: right" v-model="txnAmountDr" :minFractionDigits="2"
                         :maxFracionDigits="4"
                         v-if="txnAmountCr > 0" disabled/>
            <InputNumber id="drAmount" bodyStyle="text-align: right" v-model="txnAmountDr" :minFractionDigits="2"
                         :maxFracionDigits="4"
                         v-else/>
          </div>
          <div v-if="this.account.enableCostCenter" class="p-field p-col-12 p-md-1">
            <label for="drAmount">Debit Amount</label>
            <InputNumber id="drAmount" bodyStyle="text-align: right" v-model="txnAmountDr" :minFractionDigits="2"
                         :maxFracionDigits="4"
                         v-if="txnAmountCr > 0" disabled/>
            <InputNumber id="drAmount" bodyStyle="text-align: right" v-model="txnAmountDr" :minFractionDigits="2"
                         :maxFracionDigits="4"
                         v-else/>
          </div>

          <div v-if="!this.account.enableCostCenter" class="p-field p-col-12 p-md-2">
            <label for="crAmount">Credit Amount</label>
            <InputNumber id="crAmount" bodyStyle="text-align: right" v-model="txnAmountCr" :minFractionDigits="2"
                         :maxFracionDigits="4"
                         v-if="txnAmountDr > 0" disabled/>
            <InputNumber id="crAmount"
                         bodyStyle="text-align: right" v-model="txnAmountCr"
                         :minFractionDigits="2" :maxFracionDigits="4"
                         v-else/>
          </div>
           <div v-if="this.account.enableCostCenter" class="p-field p-col-12 p-md-1">
            <label for="crAmount">Credit Amount</label>
            <InputNumber id="crAmount" bodyStyle="text-align: right" v-model="txnAmountCr" :minFractionDigits="2"
                         :maxFracionDigits="4"
                         v-if="txnAmountDr > 0" disabled/>
            <InputNumber id="crAmount"
                         bodyStyle="text-align: right" v-model="txnAmountCr"
                         :minFractionDigits="2" :maxFracionDigits="4"
                         v-else/>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="shortNarr">Short Narration</label>
            <!-- <input type="text" id="shortNarr" v-model="narration3"/> -->
            <InputText id="shortNarr" v-model="narration3"/>
          </div>
          <div class="p-field p-mt-5 p-col-12 p-md-2" v-if="account.enableCostCenter">
            <Button  class="p-button-raised "
                    @click.prevent="openCostCenter" label="Cost Center"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="!account.isBankAccount">
            <Button class="p-button p-component addNewBtn btn-btm-0"  @click.prevent="addTransactionToDTO" :label="!editDTO?'Add':'Update'" />

          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="!account.isBankAccount">
            <Button v-show="editDTO" class="p-button-raised p-button-danger"
                    @click.prevent="resetAccountDto" label="Cancel"/>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="closingBalance" v-if="account.closingBalance >= 0 || account.closingBalance < 0">Cur.
              Bal:</label>
            <b style="color:red;" v-if="account.closingBalance>0">{{ account.closingBalance + ' ' + 'Cr' }}</b>
            <b v-else-if="account.closingBalance===0">
              {{ (account.closingBalance).toFixed(2) }}
            </b>
            <b style="color:green;" v-else-if="account.closingBalance < 0">
              {{ (account.closingBalance).toFixed(2) * (-1) + ' ' + 'Dr' }}
            </b>
          </div>
          <div class="p-field p-col-12 p-md-2"></div>
          <div class="p-field p-col-12 p-md-2" v-show="account.isBankAccount">
            <label>Cheque Date</label>
            <date-picker v-model="chequeDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="chequeDate"
                       v-model="chequeDate"/>
          </div>
          <div class="p-field p-mt-5 p-col-12 p-md-2" v-show="account.isBankAccount">
            <label for="chequeNo">Cheque No</label>
            <InputText id="chequeNo" v-model="chequeNumber"/>
          </div>

          <div class="p-field p-mt-5 p-col-12 p-md-1 align-self-end" v-if="account.isBankAccount">
            <Button class="p-button p-component addNewBtn btn-btm-0"
                    @click.prevent="addTransactionToDTO" :label="!editDTO?'Add':'Update'"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="account.isBankAccount">
            <Button v-show="editDTO" class="p-button-raised p-button-danger"
                    @click.prevent="resetAccountDto" label="Cancel"/>
          </div>
        </div>
      </form>
      <div class="container-fluid">
        <div >
          <div class="jouscroll">
            <table class="table table-bordered">
              <thead>
              <tr>
                <th scope="col">SN</th>
                <th scope="col">Account Name</th>
                <th scope="col">Debit Amount</th>
                <th scope="col">Credit Amount</th>
                <th scope="col" >Cheque Date</th>
                <th scope="col" >Cheque Number</th>
                <th scope="col">Short Narration</th>
                <th scope="col">Bills Detail</th>
                <th scope="col" >Cost Center</th>
                <th scope="col">Action</th>
              </tr>
              </thead>
              <tbody v-for="(account,index) in transactionDetailDTOList " :key="index">
              <tr>
                <td>{{ index + 1 }}</td>
                <td>{{ account.accountMaster.name }}</td>
                <td>{{ account.drCr == 'D' ? account.txnAmount : '' }}</td>
                <td>{{ account.drCr == 'C' ? account.txnAmount : '' }}</td>
                <td >{{ account.chequeDate }}</td>
                <td >{{ account.chequeNumber }}</td>
                <td>{{ account.narration3 }}</td>
                <td v-if="account.accountMaster.isBankAccount===false && account.accountMaster.isCashAccount===false">
                  <Button label="Bill detail" class="p-button-raised p-button-info"
                          @click="billDetailDialog"/>
                </td>
                <td v-else/>
                 <td v-if="!account.enableCostCenter">
                  <a href="" @click.prevent="viewCostCenterDialog(account)">Cost Center</a>
                  <!-- <Button label="Cost Center" class="p-button-raised p-button-info"
                          @click="viewCostCenterDialog(account)"
                  /> -->
                </td>
                <td>
                  <Button class="p-button-raised p-button-success"
                          @click="editAccountFromDTO(account, index)" icon="pi pi-pencil"/>
                  <Button class="p-button-raised p-button-danger"
                          @click="deleteAccountFromDTO(account,index)" icon="pi pi-trash"/>
                </td>
              </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2">Total:</td>
                  <td>{{ drtotal.toFixed(4) }}</td>
                  <td>{{  crTotal.toFixed(4) }}</td>
                  <td>&nbsp;</td>
                  <td colspan="1">Diff Amt:</td>
                  <td colspan="1">
                  <span style="margin-left:2em;color:green;font-size: 12px;"
                v-if="calculation===0">{{ calculation.toFixed(4) }}</span>
          <span v-else style="margin-left:2em;color:red;font-size: 12px;">{{ calculation.toFixed(4) }}</span>
                  </td>        
        </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <!-- <hr>

        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-3">
            <label class="_drcr" style="margin-left:14em;">Total</label>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <span style="margin-left:12em;color:#3c8dbc;font-size: 12px;">{{ drtotal.toFixed(4) }}</span>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <span style="margin-left:5em;color:#3c8dbc;font-size: 12px;">{{ crTotal.toFixed(4) }}</span>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label class="_drcr">Diff Amt</label>
            <span style="margin-left:2em;color:green;font-size: 12px;"
                  v-if="calculation===0">{{ calculation.toFixed(4) }}</span>
            <span v-else style="margin-left:2em;color:red;font-size: 12px;">{{ calculation.toFixed(4) }}</span>
          </div>
           <div class="p-field p-col-12 p-md-2" v-if="this.$store.getters.modules.includes('5.31')">
            <Button id="imageUpload" @click.prevent="showItemUpload" class="p-button-raised"
                    label="Upload Image"/>
          </div>
        </div>
        <hr> -->
      </div>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-3">
          <label for="narration1">Narration</label>
          <TextArea
            id="narration1"
            cols="15"
            rows="6"
            v-model="narration"
          />
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label>Received By</label>
          <InputText id="payedBy" v-model="paidBy"/>
        </div>
        <div class="p-field p-col-12 p-md-1 p-pt-6">
          <Button class="p-button-raised p-button-danger" @click="goBack()"
                  v-if="this.payment!=undefined">Cancel
          </button>
        </div>
        <div class="p-field p-col-12 p-md-1 p-pt-6">
          <Button icon="pi pi-refresh" class="p-button-raised p-button-warning" @click.prevent="reset"
                  v-if="this.payment==undefined" label="Reset"/>
        </div>
        <div class="p-field p-col-12 p-md-1 p-pt-6">
          <Button icon="pi pi-save" class="p-button-raised" @click="savePaymentEntry"
                  :label="!editing?'Save':'Update'"/>
        </div>
        <div class="p-field p-col-12 p-md-1 p-pt-6">
          <Button class="p-button-raised p-button-info" @click="openVoucher()" icon="pi pi-print"
                  label="Print"/>
        </div>
        <div class="p-field p-col-12 p-md-2 p-pt-6">
          <Button icon="pi pi-download" class="p-button-raised p-button-secondary"
                  label="Generate PDF"/>
        </div>
      </div>
    </div>
    <Dialog header="Purchase Bill List" :visible.sync="billDialog"
            :style="{width: '60vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'auto'}">
      <form>
        <DataTable
          :value="inOutHeaderDTOList"
          :paginator="true"
          :rows="8"
          :first="0"
          class="p-datatable-responsive p-datatable-customers"
        >
          <Column field="purchaseDate" headerStyle="width:10em" header="Date">
          </Column>
          <Column field="purchaseSalesDateNepali" headerStyle="width:10em" header="Nepali Date">
          </Column>
          <Column field="billNo" header="Bill No">
          </Column>
          <Column field="totalBillAmount" header="Bill Amount">
          </Column>
          <Column field="" header="Due Amount">
            <template #body="slotProps">{{ slotProps.data.totalBillAmount - slotProps.data.cashPaidReceived }}
            </template>
          </Column>
          <Column field="remarks" header="Remarks">
          </Column>
          <Column header=" Amount" headerStyle="width:10em" field="amountTobeDeduct">
            <template #body="slotProps">
              <input type="text" class="form-control" @change="checkAmountEntered(slotProps.data)"
                     v-model="slotProps.data[slotProps.column.field]"/>
            </template>
          </Column>


        </DataTable>
        <Button class="p-button-danger p-button-raised p-button-rounded"
                @click.prevent="closeBillDialog" label="Close"/>
      </form>
    </Dialog>
     <Dialog header="Cost Center" :visible.sync="costCenterDialog"
            :style="{width: '60vw'}" :modal="true" :closable=false
            :contentStyle="{'overflow': 'visible'}">
      <DataTable :value="costCenterList" :paginator="true" :rows="5"
                 class="p-datatable-responsive p-datatable-gridlines">
        <Column header="Name" field="costCenter">
          <template #body="slotProps">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="costCenterForTransactionLists"
                          optionLabel="name" v-if="viewCostCenter" disabled
                          placeholder="Select One"
                          :filter="true"/>
                          <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="costCenterForTransactionLists"
                          optionLabel="name"
                          placeholder="Select One" v-else
                          :filter="true"/>
              </div>
            </div>
          </template>
        </Column>
        <Column header="Amount" field="costCenterAmt">
          <template #body="slotProps">
            <InputNumber v-if="viewCostCenter" disabled v-model="slotProps.data[slotProps.column.field]" mode="decimal" locale="en-IN"
                         :minFractionDigits="2"/>
             <InputNumber v-else v-model="slotProps.data[slotProps.column.field]" mode="decimal" locale="en-IN"
                         :minFractionDigits="2"/>
          </template>
        </Column>
        <Column v-if="!viewCostCenter"  header="Action">
          <template #body="slotProps">
            <Button class="p-button-raised p-button-rounded" icon="pi pi-plus"
                    @click.prevent="addToCostCenterList()"/>
            <Button class="p-button-raised p-button-danger" icon="pi pi-minus"
                    @click.prevent="subCostCenterList(slotProps.index)"/>
          </template>
        </Column>
      </DataTable>
      <template #footer>
        <Button class="p-button-raised p-button-rounded" label="Save"
                @click.prevent="addCostCenter"/>
        <Button class="p-button-raised p-button-danger" label="Cancel"
                @click.prevent="cancelCostCenter"/>
      </template>
    </Dialog>
    <Dialog header="Item Image Upload" :modal="true" :visible.sync="showItemUploadDialog" :style="{width:'50vw'}">
          <input id="imageUpload" type="file" style="margin-bottom: 2em;" @change="onFileSelect" multiple/>
          <Carousel :value="url" :numVisible="2" :numScroll="2">
            <template #item="slotProps">
              <div class="product-item">
                <div class="product-item-content">
                  <div class="p-mb-3">
                    <img :src="slotProps.data" style="height:250px;width:250px" class="product-image"/>
                  </div>
                  <div>
                    <div class="car-buttons p-mt-5">
                      <Button class="p-button-raised p-button-danger p-mr-2"
                              @click.prevent="removeImage(slotProps.data,slotProps)" label="Remove"/>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </Carousel>
        </Dialog>

  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import Checkbox from 'primevue/checkbox'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import Toast from 'primevue/toast'
import InputMask from 'primevue/inputmask'
import accountMasterDialog from '../accountDialog/AccountMasterDialog'
import Dialog from 'primevue/dialog'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import TextArea from 'primevue/textarea'
import Carousel from 'primevue/carousel'

export default {
  name: 'paymentEntry',
  props: ['payment'],
  data() {
    return {
      name: '',
      pdc: false,
      englishDateEnabled: true,
      transactionDate: null,
      narration: '',
      account: '',
      txnAmount: 0,
      txnAmountDr: 0,
      txnAmountCr: 0,
      narration3: '',
      paidBy: '',
      drCr: '',
      drtotal: 0,
      crTotal: 0,
      transactionDetailDTOList: [],
      transactionDeleteList: [],
      editing: false,
      voucherNo: null,
      editDTO: false,
      index: null,
      tranId: null,
      tranModuleType: null,
      loading: true,
      chequeDate: null,
      chequeDateNp: null,
      chequeNumber: '',
      bank: false,
      cheque: false,
      filteredAccounts: null,
      inOutHeaderDTOList: [],
      billDialog: false,
      data: '',
      showItemUploadDialog: false,
      url: [],
      deletedImage: [],
      imageList: [],
      images: [],
      costCenterDialog: false,
      viewCostCenter: false,
      costCenterList: [{
        costCenter: '',
        costCenterAmt: 0
      }]
    }
  },
  computed: {
    // voucherNo() {
    //   return this.$store.state.accounting.voucherNoPayment
    // },
    accountMasterList() {
      return this.$store.state.accounting.accountList
    },
    costCenterForTransactionLists() {
      return this.$store.state.costCenter.costCenterForTransactionLists
    },
    calculation() {
      let difference = 0
      this.drtotal = 0
      this.crTotal = 0
      for (let i = 0; i < this.transactionDetailDTOList.length; i++) {
        if (this.transactionDetailDTOList[i].drCr === 'D') {
          this.drtotal += parseFloat(this.transactionDetailDTOList[i].txnAmount)
        } else {
          this.crTotal += parseFloat(this.transactionDetailDTOList[i].txnAmount)
        }
        difference = (parseFloat(this.drtotal) - parseFloat(this.crTotal))
      }
      return difference
    },
    bankAndPdc() {
      if (this.account.bankAccount) {
        return true
      }
    }
  },
  mounted() {
    const promises = []
    if (this.payment === undefined) {
      promises.push(this.maxVoucherNo())
    }
    promises.push(this.accountList())
    if (this.payment !== undefined) {
      promises.push(this.editPayment())
    }
    promises.push(this.findCostCenterGroup())
    Promise.all(promises)
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Failed to load data',
          life: 10000
        })
      })
    this.checkEnglish()
    if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.state.isEnglishDateEnabled && this.journal === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async maxVoucherNo() {
      let response = await this.$store.dispatch('maxVoucherNoPayment')
      if (this.payment === undefined) {
        this.voucherNo = response.data.data
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.voucherNo
        this.narration
      }
    },
    async accountList() {
      await this.$store.dispatch('accountMasterList')
    },
    async addTransactionToDTO() {
      if (this.account === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select account!', life: 10000})
        return
      } else if (this.txnAmountDr <= 0 && this.txnAmountCr <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter amount!', life: 10000})
        return
      }
      if (this.account.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please Select valid account!', life: 10000})
        return
      }
      if (this.txnAmountDr > 0) {
        this.drCr = 'D'
        this.txnAmount = this.txnAmountDr
      } else {
        this.txnAmount = this.txnAmountCr
        this.drCr = 'C'
      }
      if (!this.account.isCashAccount && !this.account.isBankAccount) {
        let response = await this.$store.dispatch('purchaseListBillForDeduction', this.account.id)
        this.inOutHeaderDTOList = response.data.data
        if (this.inOutHeaderDTOList.length > 0) {
        }
      }
      if (!this.account.enableCostCenter) {
        this.costCenterList = null
      }
      // this.chequeNumberAndDate()
      let transaction = {
        accountMaster: this.account,
        narration3: this.narration3,
        txnAmount: this.txnAmount,
        drCr: this.drCr,
        cashAccount: this.account.isCashAccount,
        bankAccount: this.account.isBankAccount,
        chequeDate: this.chequeDate,
        chequeDateNp: this.chequeDate,
        chequeNumber: this.chequeNumber,
        costCenterTransactionDTOList: this.costCenterList
      }
      if (!this.editDTO) {
        this.transactionDetailDTOList.push({...transaction})
      } else {
        this.transactionDetailDTOList.splice(this.index, 1, {...transaction})
        this.editDTO = false
      }
      this.resetAccountDto()
      this.focusInput()
    },
    editAccountFromDTO(data, index) {
      this.resetAccountDto()
      this.editDTO = true
      this.account = data.accountMaster
      this.drCr = data.drCr
      this.chequeNumber = data.chequeNumber
      this.chequeDate = data.chequeDate
      this.chequeDateNp = data.chequeDate
      if (this.drCr === 'D') {
        this.txnAmountDr = data.txnAmount
      } else {
        this.txnAmountCr = data.txnAmount
      }
      this.narration3 = data.narration3
      this.index = index
      this.costCenterList = data.costCenterTransactionDTOList
    },
    openVoucher() {
      let data = this.data
      this.$router.push({name: 'voucher', params: {printData: data}})
    },
    billDetailDialog() {
      this.billDialog = true
    },
    closeBillDialog() {
      this.billDialog = false
    },
    cancelCostCenter() {
      this.costCenterDialog = false
    },
    checkAmountEntered(data) {
      // // debugger
      this.inOutHeaderDTOList.forEach(function (billAmt) {
        if (billAmt.id === data.id) {
          if (data.totalBillAmount < data.amountTobeDeduct) {
            this.$toast.add({
              severity: 'error',
              summary: '',
              detail: 'The amount should be equal or less than total bill amount!',
              life: 10000
            })
          }
        }
      })
    },
    async savePaymentEntry() {
      let response = ''
      let journalObject = {
        transactionDate: this.transactionDate,
        transactionNepaliDate: this.transactionDate,
        narration1: this.narration,
        // chequeNumber: this.chequeNumber,
        // chequeDate: this.chequeDate,
        // chequeDateNp: this.chequeDate,
        receivedPayedBy: this.paidBy,
        tranId: this.tranId,
        tranModuleType: this.tranModuleType,
        transactionDetailDTOList: this.transactionDetailDTOList
        // transactionDeleteList: this.transactionDeleteList
      }
      if (this.transactionDetailDTOList.length < 1) {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'The transaction must have at least two transaction heads!',
          life: 10000
        })
        return
      }
      if (this.calculation !== 0) {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Debit and credit amount should be equal!',
          life: 10000
        })
        return
      }
      for (let i = 0; i < journalObject.transactionDetailDTOList.length; i++) {
        if (journalObject.transactionDetailDTOList[i].drCr === 'Cr') {
          if (!journalObject.transactionDetailDTOList[i].cashAccount && !journalObject.transactionDetailDTOList[i].bankAccount) {
            this.$toast.add({
              severity: 'success',
              summary: '',
              detail: 'Credit must have cash or bank account!',
              life: 10000
            })
            return
          }
        }
      }
      if (this.calculation !== 0) {
        this.$toast.add({
          severity: 'success',
          summary: '',
          detail: 'Debit and credit amount should be equal!',
          life: 10000
        })
        return
      }
      const formData = new FormData()
      formData.append('journalObject', JSON.stringify(journalObject))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('files', this.images[i])
      }
      if (!this.editing) {
        this.loading = true
        response = await this.$store.dispatch('savePaymentEntry', formData)
        this.data = response.data.data
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updatePaymentEntry', formData)
        this.loading = false
        this.$router.back()
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        await this.maxVoucherNo()
        this.reset()
        this.focusAfterSave()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    async findCostCenterGroup() {
      await this.$store.dispatch('loadCostCenterForTransaction')
    },
    viewCostCenterDialog(data) {
      this.viewCostCenter = true
      this.costCenterList = data.costCenterTransactionDTOList
      this.costCenterDialog = true
    },
    openCostCenter() {
      let costCenter = {
        costCenter: this.costCenter,
        costCenterAmt: this.costCenterAmt
      }
      if (this.costCenterList.length === 0) {
        this.costCenterList.push(costCenter)
      }
      this.costCenterDialog = true
      this.viewCostCenter = false
    },
    addToCostCenterList() {
      let costCenter = {
        costCenter: this.costCenter,
        costCenterAmt: this.costCenterAmt
      }
      this.costCenterList.push(costCenter)
    },
    subCostCenterList(index) {
      if (this.costCenterList.length !== 1) {
        this.costCenterList.splice(index, 1)
      }
    },
    addCostCenter() {
      this.costCenterDialog = false
      // this.costCenterList =
    },
    async editPayment() {
      let response = await this.$store.dispatch('loadaccountLedger', this.payment)
      if (response.data.status === 'SUCCESS') {
        this.editing = !this.editing
        let resp = response.data.data
        this.chequeDate = resp.chequeDate
        this.chequeDateNp = resp.chequeDate
        if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
          this.transactionDate = resp.transactionNepaliDate
        } else {
          this.transactionDate = resp.transactionDate
        }
        this.chequeNumber = resp.chequeNumber
        this.voucherNo = resp.voucher
        this.transactionDetailDTOList = resp.transactionDetailDTOList
        this.narration = resp.narration1
        this.tranId = resp.tranId
        this.tranModuleType = this.payment.tranModuleType
      }
    },
    set_account_master(data) {
      this.account = data
    },
    resetAccountDto() {
      this.account = ''
      this.txnAmountDr = 0
      this.txnAmountCr = 0
      this.narration3 = ''
      this.payedBy = ''
      this.editDTO = false
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        this.chequeDate = this.$store.getters.nepaliNewDate
      } else {
        this.chequeDate = new Date().toISOString().slice(0, 10)
      }
      this.chequeNumber = ''
      this.costCenterDialog = false
      this.costCenterList = []
      // this.costCenterDialog = []
    },
    deleteAccountFromDTO(data, id) {
      // this.chequeNumberAndDate()
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        this.chequeDate = this.$store.getters.nepaliNewDate
      } else {
        this.chequeDate = new Date().toISOString().slice(0, 10)
      }
      if (this.editing && data.id !== null) {
        this.transactionDeleteList.push({...data})
      }
      this.transactionDetailDTOList.splice(id, 1)
    },
    showItemUpload() {
      this.showItemUploadDialog = true
    },
    onFileSelect(event) {
      let selectedFile = Array.prototype.slice.call(event.target.files)
      selectedFile.forEach(f => {
        let fileExtension = f.name.split('.').pop()
        console.log(fileExtension)
        if (fileExtension !== 'jpg' && fileExtension !== 'jpeg' && fileExtension !== 'png' && fileExtension !== 'JPG') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Please select Valid Image!', life: 10000})
          return
        }
        this.images.push(f)
        let reader = new FileReader()
        reader.onload = (e) => {
          this.url.push(e.target.result)
          // console.log(e.target.result)
        }
        reader.readAsDataURL(f)
      })
    },
    viewImage() {
      this.openImageViewer = true
    },
    back() {
      this.openImageViewer = false
    },
    removeImage(data, props) {
      if (data.id !== undefined && data !== null) {
        this.deletedImage.push(data.id)
      }
      this.url.splice(props.index, 1)
      this.imageList.splice(props.index, 1)
    },
    reset() {
      this.resetAccountDto()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.transactionDate = new Date().toISOString().slice(0, 10)
        this.chequeDate = new Date().toISOString().slice(0, 10)
      }
      this.transactionDetailDTOList = []
      this.editing = false
    },
    setNepaliDate() {
      if (this.payment === undefined) {
        this.transactionDate = this.$store.getters.nepaliNewDate
        this.chequeDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        $('#transactionDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.transactionDate = $('#transactionDate').val()
          }
        })
        if (this.account.isBankAccount) {
          this.setNepaliDate()
          $('#chequeDate').nepaliDatePicker({
            ndpYear: true,
            ndpMonth: true,
            ndpYearCount: 10,
            disableBefore: this.$store.state.startDate,
            disableAfter: this.$store.state.endDate,
            onChange: () => {
              this.chequeDate = $('#chequeDate').val()
            }
          })
        } else {
          this.chequeDate = ''
        }
      }
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredAccounts = [...this.accountMasterList]
        } else {
          this.filteredAccounts = this.accountMasterList.filter((item) => {
            return item.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },
    setEnglishDate() {
      this.transactionDate = new Date().toISOString().slice(0, 10)
      this.chequeDate = new Date().toISOString().slice(0, 10)
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    focusAfterSave() {
      this.$refs.tran.focus()
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    goBack() {
      if (this.transactionDeleteList.length > 0) {
        this.payment.transactionDetailDTOList = this.transactionDeleteList
      }
      this.$router.back()
    }
    // chequeNumberAndDate() {
    //   if (this.account.isBankAccount) {
    //     this.bank = true
    //   } else if (this.account.isBankAccount === undefined) {
    //     this.bank = false
    //   } else if (!this.account.isBankAccount) {
    //     this.bank = false
    //   }
    //   if (this.chequeNumber !== '') {
    //     this.cheque = true
    //   } else if (this.chequeNumber === '') {
    //     this.cheque = false
    //   }
    // }
  },
  components: {
    Dropdown,
    DatePicker,
    Checkbox,
    AutoComplete,
    InputNumber,
    Toast,
    InputMask,
    accountMasterDialog,
    Dialog,
    DataTable,
    Column,
    InputText,
    Button,
    TextArea,
    Carousel
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
._drcr {
  color: red;
}
</style>



// WEBPACK FOOTER //
// payment.vue?38ddbd9d